import { z } from 'zod';

export const ExplainTextResponseSchema = z.object({
  explanation: z.string().min(1, 'Explanation cannot be empty.'),
});

export type IExplainTextResponseDto = z.infer<typeof ExplainTextResponseSchema>;
